import { useCallback } from "react";
import { useNavigate } from "react-router";

import { useModulePathResolver } from "capitalrx-shell";
import { General } from "capitalrx-components-2.0";

interface HandlerOptions {
  callback?: Function;
  invalidates: Array<string>;
  message?: string;
  redirect?: string;
  redirectToEdit?: boolean;
}

/**
 * @param callback Optional: Callback for instances where you need to perform some other task.
 * @param message Optional: Can pass a custom toast message to be displayed.
 * @param redirect Optional: Path to redirect user to on successful operation.
 * @returns failureHandler
 */
export function useFailureHandler(options?: Omit<HandlerOptions, "invalidates">): (err: string | Error) => void {
  const showAlert = General.useAlert();
  const navigate = useNavigate();
  const modulePath = useModulePathResolver();

  const errorMessage = useCallback(
    (err: string | Error): string => {
      if (options?.message) return options.message;
      else if (typeof err === "string") return err;
      else {
        return err.message;
      }
    },
    [options],
  );

  return useCallback(
    (err: string | Error): void => {
      if (options?.redirect !== undefined && options?.redirect !== null) {
        navigate(modulePath(options?.redirect));
      }

      showAlert({
        type: "error",
        message: errorMessage(err),
        style: "banner",
      });

      // if there is a callback, call it
      if (typeof options?.callback == "function") {
        options?.callback();
      }
    },
    [history, showAlert, modulePath],
  );
}
